"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_empty_1 = require("../objects/is-empty");
const is_array_1 = require("../arrays/is-array");
const is_empty_2 = require("../arrays/is-empty");
/**
 * Assert whether the given object or array is empty.
 *
 * @Param {object | array} enumerable - The enumerable to assert on.
 *
 * @Example
 *
 *   isEmpty({})
 *   //=> true
 *
 *   isEmpty({ food: 'pizza' })
 *   //=> false
 *
 *   isEmpty([])
 *   //=> true
 *
 *   isEmpty(['pizza'])
 *   //=> false
 */
function isEmpty(enumerable) {
    if (is_array_1.isArray(enumerable)) {
        return is_empty_2.isEmpty(enumerable);
    }
    return is_empty_1.isEmpty(enumerable);
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=is-empty.js.map